"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

/* eslint no-magic-numbers: 0 */
var StateQueue = /*#__PURE__*/function () {
  function StateQueue(callbackFn) {
    var serializer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (val) {
      return val;
    };
    var debounce = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
    (0, _classCallCheck2["default"])(this, StateQueue);
    this.queue = [];
    this.callbackFn = callbackFn;
    this.promiseQueue = [];
    this.interval = null;
    this.storedValues = {};
    this.debounce = debounce;
    this.setStoredValues = this.setStoredValues.bind(this);
    this.serializer = serializer;
  }

  (0, _createClass2["default"])(StateQueue, [{
    key: "add",
    value: function add(entry) {
      this.queue.push(entry);

      if (!this.interval) {
        this.makePromises();
      }
    }
  }, {
    key: "setStoredValues",
    value: function setStoredValues(state) {
      var _this = this;

      return new Promise(function (resolve) {
        _this.storedValues[state.fieldId] = _this.serializer(state);
        resolve(true);
      });
    }
  }, {
    key: "finishRun",
    value: function finishRun() {
      this.callbackFn(this.storedValues);
      this.promiseQueue = [];
      this.storedValues = {};
    }
  }, {
    key: "runQueue",
    value: function runQueue() {
      var _this2 = this;

      this.promiseQueue.reduce(function (chain, task) {
        return chain.then(function () {
          return task.fn(task.args);
        });
      }, Promise.resolve([])).then(function () {
        return _this2.finishRun();
      });
    }
  }, {
    key: "makePromises",
    value: function makePromises() {
      var _this3 = this;

      this.interval = setInterval(function () {
        if (_this3.queue.length > 0) {
          return _this3.promiseQueue.push({
            fn: _this3.setStoredValues,
            args: _this3.queue.shift()
          });
        }

        clearInterval(_this3.interval);
        _this3.interval = null;
        return _this3.runQueue();
      }, this.debounce);
    }
  }]);
  return StateQueue;
}();

var _default = StateQueue;
exports["default"] = _default;